/* eslint-disable eqeqeq */
import React, { useState } from "react";
import { CardTitle } from "../ui/card";
import { Label } from "../ui/label";
import CustomLabelText from "../CustomLabelText";
import SearchSelect from "../SearchSelect";
import { Button } from "../ui/button";
import { Eye, LucidePlusCircle } from "lucide-react";
import { ResponsiveDrawerForm } from "../ResponsiveDrawerForm";
import AddEditRiskAssessment from "../../pages/AML-CTF/Program/RiskAssessment/AddEditRiskAssessment";
import { formatName } from "../../lib/Misc";
import { cddCustomerTypeOptions, cddOptions, riskProfile } from "../../config";
import RiskAssessmentDetailsPopup from "../../pages/AML-CTF/Program/RiskAssessment/RiskAssessmentDetailsPopup";
import { Textarea } from "../ui/textarea";
import { FieldArray } from "formik";
import BeneficaryRow from "../BeneficaryRow";
import { faLandmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CustomTooltip from "../CustomTooltip";
import { InfoCircledIcon } from "@radix-ui/react-icons";

const AssessmentStep = ({
  values,
  errors,
  setFieldValue,
  handleChange,
  handleBlur,
  edit,
  mainData,
  organizationData,
  sectionType,
  setSectionType,
  validateField,
  setTouched,
}) => {
  const [showAssessment, setShowAssessment] = useState(false);
  const [viewAssessment, setViewAssessment] = useState(false);

  const toggleAssessment = () => {
    setShowAssessment(!showAssessment);
  };

  const toggleViewAssessment = () => {
    setViewAssessment(!viewAssessment);
  };
  return (
    <div className="grid gap-4 pt-4">
      <CardTitle className="text-md">
        <div className="flex w-full items-center justify-between">
          <div>Risk Assessment</div>
          {/* <div className="flex gap-2 items-center">
                <Label>
                  <CustomLabelText
                    labelText="KYC"
                    errorField={errors?.is_kyc}
                  />
                </Label>
                <div className="flex items-center gap-4">
                  {mainData?.kyc?.status && (
                  <Button>Reverify</Button>
                )}
                  <Switch
                  name="is_kyc"
                  checked={values?.is_kyc}
                  onCheckedChange={(checked) =>
                    setFieldValue("is_kyc", checked)
                  }
                  onBlur={handleBlur}
                />
                </div>
            </div> */}
        </div>
      </CardTitle>
      {values?.is_kyc && (
        <>
          <div className="grid md:grid-cols-4 gap-4">
            <div className="grid gap-2">
              <div className="min-w-0">
                <Label htmlFor="cdd">
                  <CustomLabelText
                    labelText="CDD Customer Type"
                    errorField={errors?.cdd_customer_type}
                  />
                </Label>
                <div className="relative mt-2">
                  <SearchSelect
                    frameworks={cddCustomerTypeOptions}
                    optionType={"CDD Customer Type"}
                    handleSelect={(e) => {
                      setSectionType(
                        `Onboarding-${e === "1" ? "Ongoing" : "Initial"}`,
                      );
                      setFieldValue("cdd_customer_type", e);
                    }}
                    handleBlur={handleBlur}
                    className={
                      errors?.cdd_customer_type &&
                      `focus-visible:ring-red-500 border-red-500`
                    }
                    disabled={edit && mainData?.kyc?.status ? true : false}
                    initialValue={values?.cdd_customer_type}
                  />
                </div>
              </div>
            </div>

            {values?.cdd_customer_type && (
              <div className="grid gap-2">
                <div className="min-w-0">
                  <Label htmlFor="risk_assessment_id">
                    <CustomLabelText
                      labelText={
                        <div className="flex items-center gap-2 justify-between">
                          <span>Risk Assessment</span>
                          {values?.type == 2 && values?.entity_type ? (
                            <CustomTooltip
                              message={
                                "Risk Assessment is required for verification."
                              }
                            >
                              <InfoCircledIcon className="text-webPrimary" />
                            </CustomTooltip>
                          ) : (
                            <></>
                          )}
                        </div>
                      }
                      errorField={errors?.risk_assessment_id}
                    />
                  </Label>
                  <div className="relative mt-2">
                    {values?.risk_assessment_id ? (
                      <Button
                        className="w-full justify-start h-9"
                        onClick={(e) => {
                          e.preventDefault();
                          toggleViewAssessment();
                        }}
                      >
                        <span className="flex gap-2 justify-start">
                          <Eye size={18} />
                          Risk Assessment
                        </span>
                      </Button>
                    ) : (
                      <ResponsiveDrawerForm
                        description={""}
                        title={"Add Assessment"}
                        handleOpen={() => {}}
                        popupType={"risk-assessments"}
                        handleClose={() => {
                          setShowAssessment(false);
                        }}
                        buttonText={
                          <div className="flex items-center gap-1">
                            <LucidePlusCircle size={18} />
                            <span>Conduct</span>
                          </div>
                        }
                        className={"overflow-hidden"}
                        open={showAssessment}
                        buttonClassName={"w-full justify-start h-9"}
                        setOpen={setShowAssessment}
                        write={true}
                      >
                        <AddEditRiskAssessment
                          edit={false}
                          toggleShowAddEditRisk={toggleAssessment}
                          id={""}
                          sectionType={sectionType}
                          organizationId={organizationData?.organizationId}
                          customerName={
                            formatName(values?.first_name, values?.last_name) +
                            (values?.business_name
                              ? ` (${values?.business_name})`
                              : "")
                          }
                          customerType={
                            values?.type == 2 ? "Non Individual" : "Individual"
                          }
                          setFieldValue={setFieldValue}
                          fetchRiskData={() => {}}
                          setTouched={setTouched}
                          validateField={validateField}
                        />
                      </ResponsiveDrawerForm>
                    )}
                  </div>
                </div>
              </div>
            )}

            <div className="grid gap-2">
              <div className="min-w-0">
                <Label htmlFor="risk">
                  <CustomLabelText
                    labelText="Risk Profile"
                    errorField={errors?.risk}
                  />
                </Label>
                <div className="relative mt-2">
                  <SearchSelect
                    frameworks={riskProfile}
                    optionType={"Risk Profile"}
                    handleSelect={(e) => {
                      setFieldValue("risk", e);
                    }}
                    handleBlur={handleBlur}
                    className={
                      errors?.risk &&
                      `focus-visible:ring-red-500 border-red-500`
                    }
                    disabled={edit && mainData?.kyc?.status ? true : false}
                    initialValue={values?.risk}
                  />
                </div>
              </div>
            </div>

            <div className="grid gap-2">
              <div className="min-w-0">
                <Label htmlFor="cdd">
                  <CustomLabelText
                    labelText="CDD Type"
                    errorField={errors?.cdd}
                  />
                </Label>
                <div className="relative mt-2">
                  <SearchSelect
                    frameworks={cddOptions}
                    optionType={"CDD Type"}
                    handleSelect={(e) => {
                      setFieldValue("cdd", e);
                    }}
                    handleBlur={handleBlur}
                    className={
                      errors?.cdd && `focus-visible:ring-red-500 border-red-500`
                    }
                    disabled={edit && mainData?.kyc?.status ? true : false}
                    initialValue={values?.cdd}
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {values?.type == "2" && values?.entity_type != "1" ? (
        <>
          <CardTitle className="text-md">
            <div className="flex w-full items-center justify-between">
              <div>KYB Verifications</div>
              {values?.beneficiaries?.length > 0 &&
              values?.risk_assessment_id &&
              values?.beneficiaries?.some(
                (item) =>
                  item?.first_name && item?.last_name && item?.percentage,
              ) ? (
                <Button
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                  className={"bg-[#096600] w-fit h-6"}
                >
                  <div className="flex items-center gap-1">
                    <FontAwesomeIcon
                      icon={faLandmark}
                      size="1x"
                      title="Pass"
                      className="rag-white"
                    />

                    <span>Verified</span>
                  </div>
                </Button>
              ) : (
                <></>
              )}
            </div>
          </CardTitle>

          <FieldArray name="beneficiaries">
            {({ push, remove }) => (
              <div className="space-y-6">
                {values?.beneficiaries?.map((row, index) => (
                  <BeneficaryRow
                    key={index}
                    index={index}
                    values={values}
                    push={push}
                    errors={errors}
                    remove={remove}
                  />
                ))}

                {values?.beneficiaries?.length === 0 && (
                  <Button
                    type="button"
                    variant="outline"
                    onClick={() =>
                      push({
                        first_name: "",
                        last_name: "",
                        percentage: "",
                      })
                    }
                  >
                    Add Beneficiaries
                  </Button>
                )}
              </div>
            )}
          </FieldArray>

          <div className="grid md:grid-cols-1 gap-4">
            <div className="grid gap-2">
              <Label htmlFor="notes">
                <CustomLabelText labelText="Note" errorField={errors?.notes} />
              </Label>
              <Textarea
                name="notes"
                rows={4}
                placeholder="How did you verify Individual's Full Name AND Either Residential Address OR DOB? Or add reasoning/notes."
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.notes}
                // disabled={edit && mainData?.kyc?.status ? true : false}
              />
            </div>
          </div>

          <div className="grid md:grid-cols-1 gap-4">
            <div className="grid gap-2">
              <Label htmlFor="ntf_note">
                <CustomLabelText
                  labelText="Nature & Purpose of Transaction"
                  errorField={errors?.ntf_note}
                />
              </Label>
              <Textarea
                name="ntf_note"
                rows={4}
                placeholder="Write a note of Nature & Purpose of Transaction"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.ntf_note}
                // disabled={edit && mainData?.kyc?.status ? true : false}
              />
            </div>
          </div>
        </>
      ) : (
        <></>
      )}

      {viewAssessment && (
        <RiskAssessmentDetailsPopup
          showView={viewAssessment}
          id={values?.risk_assessment_id}
          toggleShowModal={toggleViewAssessment}
          setShowView={setViewAssessment}
          sectionType={sectionType}
        />
      )}
    </div>
  );
};

export default AssessmentStep;
